import { routes } from 'constants/config';
import { IN_PERSON_TRAINING } from 'constants/actionTypes';
import request from 'utils/request_ajax';
import createActionsCreators from 'utils/createActionsCreators';

const actions = createActionsCreators({
  dataRequest: IN_PERSON_TRAINING.EVENTS_DASHBOARD.DATA_REQUEST,
  dataReceive: IN_PERSON_TRAINING.EVENTS_DASHBOARD.DATA_RECEIVE,
});

export function requestEvents() {
  return async dispatch => {
    dispatch(actions.dataRequest());
    const events = await request.get(
      routes.IN_PERSON_TRAINING.EVENTS_DASHBOARD,
    );
    dispatch(actions.dataReceive(events));
  };
}
